module.exports = __webpack_public_path__ + "static/media/default-character.17b13028.png";